{
  "version": 1,
  "asset_id": "e960896e-3fe5-4c8c-a5c1-2efada2b5404",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e960896e-3fe5-4c8c-a5c1-2efada2b5404/foreignaffairs-semrush-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e960896e-3fe5-4c8c-a5c1-2efada2b5404/foreignaffairs-semrush-1280.avif",
  "original_filename": "foreignaffairs-semrush-1280.avif",
  "size": 24384,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:55Z"
}
